<h2 mat-dialog-title>View Cameras By Floor</h2>
<form [formGroup]="form" (ngSubmit)="submitForm()">
  <mat-dialog-content class="mat-typography">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button color="danger" type="button" mat-button mat-dialog-close>close</button>
    <button
      mat-button
      [disabled]="form.invalid"
      [mtBasicSpinner]="isLoading"
      [hideText]="true"
      color="success"
      type="submit"
    >
      submit
    </button>
  </mat-dialog-actions>
</form>
